module.exports = __webpack_public_path__ + "static/media/magicCenter.1c8d9a4d.jpg";